import React from 'react'
import HeaderPlato from '../design.system/HeaderPlato'

const LogoHeader = () => {
  return (
    <HeaderPlato>
    </HeaderPlato>
  )
}

export default LogoHeader